
import Model from '@/models/mobile'
import Icon from 'vux/src/components/icon/index.vue'

import { mapActions } from 'vuex'
export default {
components: {
Icon
},
data(){
return{
formData:{
tel:'',
parkNo:this.$route.params.parkNo,
passid:this.$route.params.passid
}
}
},
methods:{
...mapActions('mobile',{
sendData:'setDataAction'
}),
submit(){
if(!/^1[3-9]\d{9}$/.test(this.formData.tel)) {
this.$layer.msg('请输入正确的手机号码');
return;
}
sessionStorage.setItem('isNoCar',1)
if(this.$route.query.pay==1){
let _data={
tdid:this.formData.passid,
parkno:this.formData.parkNo,
carno:this.formData.tel.replace(/\s+/g,"")
}
this.sendData(_data).then(()=>{
this.$router.push({path:`/mobile/confirmMsg/${this.formData.tel}`})
})
}else{
this.sendPhone()
}
},
async sendPhone(){
let { data } = await Model.sendPhone(this.formData);
}
},
created() {
let tel = localStorage.getItem('carNo');
if(!isNaN(tel)) {
this.formData.tel = tel;
}
}
}



// WEBPACK FOOTER //
// ./src/pages/mobile/enterPhone.vue